const ofertaCA = () => {
  let infoCA = {
    tarjetas: ["visa-debito-nacional"],
    oferta: [
      {
        label: "Caja de ahorro en pesos",
        description: ""
      },
      {
        label: "Tarjeta <strong>Visa Débito</strong>",
        description: ""
      }
    ],
    beneficios: require(`@/config/brands/${_BBVA_MOTOR}.js`).beneficios,
    legales: `CARTERA DE CONSUMO. VIGENCIA 01/04/2023 a 30/06/2023. 
    Mantenimiento Mensual: $0.
    (*) Para más información consulta en 
    https://www.bbva.com.ar/personas/productos/prestamos/personales/pesos.html
    <br/> AVISO LEGAL
    Los depósitos en pesos y en moneda extranjera cuentan con la garantía de hasta $1.000.000. 
    En las operaciones a nombre de dos o más personas, la garantía se prorrateará entre sus titulares. 
    En ningún caso, el total de la garantía por persona y por depósito podrá exceder de $1.000.000, 
    cualquiera sea el número de cuentas y/o depósitos. Ley 24.485, Decreto 540/95 y Com. “A” 2337 y 
    sus modificatorias y complementarias. Se encuentran excluidos los captados a tasas superiores a 
    la de referencia, los que hayan contado con incentivos o retribuciones especiales diferentes de 
    la tasa de interés, los adquiridos por endoso y los efectuados por personas vinculadas a la entidad 
    financiera. Los depósitos de perfil Cuenta Básica se encuentran excluidos del régimen de garantía 
    de los depósitos. Los accionistas de BANCO BBVA ARGENTINA S.A. limitan su responsabilidad a la 
    integración de las acciones suscriptas a la ley 19.550 y ley 25.738. CUIT 30-50000319-3. 
    Av. Córdoba 111, piso 31, CABA - CP 1054.`
  };

  return infoCA;
};

export default ofertaCA;
